import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Reviews from './pages/Reviews';
import About from './pages/About';
import BookWedding from './pages/BookWedding';
import BookBirthday from './pages/BookBirthday';
import BookTrip from './pages/BookTrip';
import Allblogs from './pages/Allblogs';
import './main.css';

// Lazy load each blog page – if one fails, the error boundary will show a fallback
const Blog1 = lazy(() => import('./pages/Blog1').catch(() => ({ default: BlogFallback })));
const Blog2 = lazy(() => import('./pages/Blog2').catch(() => ({ default: BlogFallback })));
const Blog3 = lazy(() => import('./pages/Blog3').catch(() => ({ default: BlogFallback })));
const Blog4 = lazy(() => import('./pages/Blog4').catch(() => ({ default: BlogFallback })));
const Blog5 = lazy(() => import('./pages/Blog5').catch(() => ({ default: BlogFallback })));
const Blog6 = lazy(() => import('./pages/Blog6').catch(() => ({ default: BlogFallback })));
const Blog7 = lazy(() => import('./pages/Blog7').catch(() => ({ default: BlogFallback })));

// Fallback component for any blog that fails to load
function BlogFallback() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Blog Unavailable</h1>
        <p className="text-gray-600 mb-8">This blog post could not be loaded. Please try again later.</p>
        <a href="/blogs" className="px-6 py-3 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-semibold rounded-full">
          Back to Blogs
        </a>
      </div>
    </div>
  );
}

// Simple loading spinner
function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/reviews" element={<Reviews />} />

            {/* Booking Pages */}
            <Route path="/book-wedding" element={<BookWedding />} />
            <Route path="/book-birthday" element={<BookBirthday />} />
            <Route path="/book-trip" element={<BookTrip />} />

            {/* Blogs Listing */}
            <Route path="/blogs" element={<Allblogs />} />

            {/* Individual Blog Posts */}
            <Route path="/blog/1" element={<Blog1 />} />
            <Route path="/blog/2" element={<Blog2 />} />
            <Route path="/blog/3" element={<Blog3 />} />
            <Route path="/blog/4" element={<Blog4 />} />
            <Route path="/blog/5" element={<Blog5 />} />
            <Route path="/blog/6" element={<Blog6 />} />
            <Route path="/blog/7" element={<Blog7 />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-yellow-50 to-pink-50 px-4">
      <div className="text-center">
        <h1 className="text-6xl md:text-7xl font-bold text-yellow-500 mb-4">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/"
            className="px-8 py-3 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-semibold rounded-full hover:shadow-lg"
          >
            Go to Homepage
          </a>
          <a
            href="/blogs"
            className="px-8 py-3 bg-white text-gray-700 font-semibold rounded-full hover:bg-yellow-50 border border-yellow-200"
          >
            Browse Blogs
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;